// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const notificationsSections: PaneSection[] = [
  {
    section: 'intro',
    title: 'Notifications',
    body: 'Decide how and when Ping alerts you. The settings below only affect this device.',
  },
  {
    section: 'enable',
    title: 'Enable notifications',
    body: 'The master switch. Turn it off to silence every alert on this device at once.',
  },
  {
    section: 'background',
    title: 'Background alerts',
    body: 'Get a system notification when Ping is in the background or another app is in front. You may need to allow this in your system settings.',
  },
  {
    section: 'preview',
    title: 'Message preview',
    body: 'Choose how much of an incoming message shows in an alert, from the full text down to nothing at all.',
  },
  {
    section: 'sounds',
    title: 'In-app sounds',
    body: 'Play a chime when new messages and mentions come in while you have Ping open.',
  },
  {
    section: 'quiet',
    title: 'Quiet hours',
    body: 'Silence alerts during a daily window you set. Mentions still come through so you do not miss anything important.',
  },
];
